import { isObject, isString } from 'lodash-es';

const mapFieldName = (field, parents: string[] = []) =>
  `${parents.join('.')}${parents.length > 0 ? '.' : ''}${field.name}`;

export const mapSchemaToSelect = (schema) => {
  const results: string[] = [];

  const mapFields = (fields: any[], parents: string[] = []) => {
    for (const field of fields) {
      if (isString(field.type)) {
        const name = mapFieldName(field, parents);

        results.push(name);
      } else if (Array.isArray(field.type)) {
        const nestedRecords = field.type.filter(
          (t) => isObject(t) && (t as any).type === 'record'
        );

        if (!nestedRecords.length) {
          const name = mapFieldName(field, parents);
          results.push(name);
        } else {
          for (const subtype of field.type) {
            if (subtype.type === 'record' && subtype.fields?.length > 0) {
              mapFields(subtype.fields, [...parents, field.name]);
            }
          }
        }
      }
    }
  };

  mapFields(schema.fields);

  return results;
};
